export const HOST = [
    'https://trade-us-test.qa.tigerbrokers.net',
    'https://trade.tradeup.com',
    'https://trade-qa22.test.tigerbrokers.net'
];
export const API = {
    // 接口文档地址: https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=60919803#WebAPI(Marsco)-%E5%AF%B9%E8%B4%A6%E5%8D%95%E2%80%94%E2%80%94%E8%8E%B7%E5%8F%96statements%E5%88%97%E8%A1%A8%E5%8F%8A%E4%B8%8B%E8%BD%BD%E5%9C%B0%E5%9D%80
    viewDoc: {
        getStatements: '/report/statements', // 获取statements列表及下载地址
        getTaxDocuments: '/report/tax-documents', // 获取tax document列表及下载地址
        getTradeConfirms: '/report/confirmations', // 获取指定时间范围内的trade confirm列表及下载地址
        downloadDoc: '/report/download/:id' // 根据下载地址获取对账单文件
    },

    marscoClose: {
        // https://git.tigerbrokers.net/alpha/site-api-docs/-/blob/master/api/account_managements.md#%E5%85%B3%E9%97%AD%E5%B8%90%E6%88%B7%E6%A3%80%E6%9F%A5
        getPositionCloseStatus: '/accounts/close_check',
        // https://git.tigerbrokers.net/alpha/site-api-docs/-/blob/master/api/account_managements.md#%E6%8F%90%E4%BA%A4%E5%85%B3%E6%88%B7%E7%94%B3%E8%AF%B7
        submitMarscoClose: '/accounts/submit_close',
        // https://git.tigerbrokers.net/alpha/site-api-docs/-/blob/master/api/funding-site/funds.md#%E5%9C%A8%E9%80%94%E8%B5%84%E9%87%91%E7%BB%9F%E8%AE%A1
        getFundCloseStatus: '/funding/funds/intransit-amount'
    },
    reports: {
        // 获取syep利息明细: https://git.tigerbrokers.net/alpha/site-api-docs/-/blob/us-syep/user_report/syep.md?ref_type=heads
        getSyepDetails: '/user_ledger_records/interest/syep/details'
    },
    /**
     * marsco可出金金额
     * https://git.tigerbrokers.net/alpha/site-api-docs/-/blob/master/api/asset.md
     */
    withdrawableCash: '/funding/withdrawable',
    // https://tigertech.feishu.cn/wiki/wikcnJV3cJXSpI9KNPFtuosEScd#Mcra59
    predict: '/funding/instant-funding/predict',

    history: {
        // https://git.tigerbrokers.net/alpha/site-api-docs/blob/master/api/asset.md#-%E6%9F%A5%E8%AF%A2%E7%94%A8%E6%88%B7%E5%8F%AF%E5%8F%96%E8%B5%84%E9%87%91
        // @檀威(此接口是提供ach出入金记录)
        getTransferRecord: '/funding/funds/deposit_withdrawal',

        // @huangyuming(此接口是提供wire出金记录)
        getWireWithdrawRecords: '/withdrawals',
        getItemWireWithdrawRecord: '/withdrawals/:id',
        // 取消wire出金
        cancelWireWithdraw: '/withdrawals/:id/cancel'
    },

    funding: {
        /**
         * https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=95405834
         * 获取用户是否有当前能力（ach/wire）
         */
        getBlackHouseEnable: '/funding/restriction/status',
        // https://git.tigerbrokers.net/alpha/bos-api-docs/-/blob/master/ach/achBindCard.md
        getCardList: '/funding/bank/api/v2/individual/deposit/card', // 获取入金银行卡List(新)
        getLinkToken: '/funding/bank/api/v1/individual/deposit/card/auth/link_token',
        refreshCard: '/funding/bank/api/v2/individual/deposit/card/auth/refresh', // 账户凭证刷新
        bindCardStep1: '/funding/bank/api/v2/individual/deposit/card/auth', // 绑定银行卡第一步
        bindCardStep2: '/funding/bank/api/v2/individual/deposit/card', // 绑定银行卡第二步
        deleteCard: '/funding/bank/api/v2/individual/deposit/card/auth/delete', // 删除绑定银行卡
        getBalance: '/funding/bank/api/v1/individual/fund/balance', // 查询帐户余额
        submitDeposit: '/funding/bank/api/v2/individual/deposit/ach', // 提交入金 v2不需要两步验证也可以提交入金
        submitWithDraw: '/funding/bank/api/v2/individual/withdraw/ach', // 提交出金 v2不需要两步验证也可以提交出金
        availableCash: '/funding/bank/api/v1/individual/fund/available_cash', // 可出入金金额查询
        getHistory: '/funding/bank/api/v1/individual/fund/record', // 出入金历史
        depositAch: '/funding/bank/api/v1/individual/deposit/ach', // TODO: 只针对ib账户调用接口 ACH入金
        withdrawAch: '/funding/bank/api/v1/individual/withdraw/ach', // TODO: 只针对ib账户调用接口 ACH出金
        getCacheLinkToken: '/funding/bank/api/v1/card/auth/link_token/cache', // 获取缓存plaid的link_token
        // https://apidocs.tigerfintech.com/repository/77/api/master/funding-site-bank.json#/operations/post-bank-api-v2-deposit-ach-plan
        createDepositAchPlan: '/funding/bank/api/v2/deposit/ach/plan', // 定时入金提交
        modifyDepositAchPlan: '/deposit_applications/plans/:id', // 修改定时入金计划
        cancelDepositAchPlan: '/deposit_applications/:id/cancel', // 取消定时入金计划
        getDepositAchPlanList: '/deposit_applications/plans', // 获取定时入金计划列表
        getDepositAchPlanDetail: '/deposit_applications/plans/:id', // 获取单个定时入金计划详情
        getDepositAchPlanHistory: '/deposit_applications/plans/:id/histories', // 获取定时入金计划的入金列表
        // https://apidocs.tigerfintech.com/repository/77/api/master/funding-site.json#/operations/get-deposit_applications-plans-count
        getDepositArchPlansCount: '/funding/deposit_applications/plans/count', // 查询定时入金计划的数量
        // https://apidocs.tigerfintech.com/repository/77/api/master/funding-site.json#/operations/get-deposit_applications-next_execute_time
        getNextExecuteTime: '/funding/deposit_applications/next_execute_time' // 查询定时入金的下次执行时间
    },
    wire: {
        withdrawableCash: '/funds/withdrawable-cash',
        submitWireWithdraw: '/withdrawals/wire'
    },
    /**
     * 公司行动
     * https://git.tigerbrokers.net/alpha/site-api-docs/-/blob/master/api/corp_actions.md
     * RD: @liuchan
     */
    corp: {
        getCorpSummary: '/corp_actions/summary', // 公司行动概要
        getCorpListByType: '/corp_actions', // 查询某一个公司行动类型列表
        getCorpDetailsById: '/corp_actions/voluntary/:id', // 查询可选公司行动详细信息
        getCorpResultPreview: '/corp_actions/voluntary/:id/preview', // 可选公司行动提交预览
        submitCorp: '/corp_actions/voluntary/:id/elections', // 提交用户的选择结果
        getHistoryResult: '/corp_actions/voluntary/:id/result', // 获取历史结果
        getHistoryRecords: '/corp_actions/voluntary/:id/elections', // 获取历史记录
        getRightsIssueDetails: '/rights/:rightsSymbol', // 获取供股详情信息
        submitRightsIssue: '/subscriptions', // 提交供股
        getRightsIssuePreview: '/subscriptions/preview', // 供股分红预览
        getRightsIssueResult: '/subscriptions/result/:rightsStockId', // 供股历史结果
        getRightsIssueRecords: '/subscriptions/history/:rightsStockId' // 供股历史记录
    },
    /**
     * https://tigertech.feishu.cn/docx/AzZLd7foWozdnSxmGb0csjsQnSH
     * RD: zhaolei
     */
    bankcards: {
        getBankCards: '/funding/bank-card/cards', // 获取银行卡列表
        getBankCardItem: '/funding/bank-card/:id', // 获取某个银行卡
        addBankCard: '/funding/bank-card', // 添加银行卡
        editBankCardItem: '/funding/bank-card/:id/update', // 修改银行卡
        deleteBankCardItem: '/funding/bank-card/:id/delete', // 删除银行卡
        uploadAuth: '/funding/bank-card/:id/upload'
    },
    deposit: {
        fillNotice: '/funding/deposit_notices',
        getRecord: '/funding/deposit_notices',
        /**
         * 查询 IRA 账户限额
         * RD: shijunjie
         * https://apidocs.tigerfintech.com/repository/77/api/master/funding-site.json#/operations/get-ira-deposit-limit
         */
        getIRALimits: '/funding/ira-deposit/limits',
        /**
         * 获取支票入金指引
         */
        getCheckInfo: '/funding/deposit_notices/check_guide',
        /**
         * 获取内转账户列表
         * RD: shijunjie
         * https://apidocs.tigerfintech.com/repository/77/api/master/funding-site.json#/operations/internal-transfer-fund-account
         */
        getTransferAccounts: '/funding/internal_transfers/funds/accounts',
        /**
         * 提交内转入金
         * RD: shijunjie
         * https://apidocs.tigerfintech.com/repository/77/api/master/funding-site.json#/operations/internal-fund-transfer-submitSameHolder
         */
        submitTransfer: '/funding/internal_transfers/funds/same_holder',
        /**
         * https://apidocs.tigerfintech.com/repository/77/api/master/funding-site.json#/operations/get-internal_transfers-funds-page
         */
        getRecordList: '/funding/internal_transfers/funds/page',
        /**
         * IRA 账户出金时获取出金原因
         * RD: shijunjie
         * https://apidocs.tigerfintech.com/repository/77/api/master/funding-site.json#/operations/get-withdrawals-v2-reasons
         */
        getWithdrawalReason: '/funding/withdrawals/v2/reasons',
        // 获取出金可选择的税年 https://apidocs.tigerfintech.com/repository/77/api/master/funding-site.json#/operations/get-withdrawals-tax_year
        getWithdrawalTaxYear: '/funding/withdrawals/tax_year'
    }
};

export function bindCG() {
    const cfg = CG_API.trade?.TBUS;

    cfg && HOST.fill(cfg);
}
